(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-cart-accessory-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rr-cart-offers')) {
    customElements.define('rr-cart-offers', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('cart-drawer');
        this.error = this.querySelector('[data-rr-offer-error]');
        this.sync = this.sync.bind(this);
        this.clickHandler = event => {
          const button = event.target.closest('[data-rr-add-offer]');
          if (button && this.contains(button)) this.add(button);
        };
        this.addEventListener('click', this.clickHandler);
        document.addEventListener('theme:cart:change', this.sync);
        document.addEventListener('theme:cart-drawer:open', this.sync);
        this.sync();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.clickHandler);
        document.removeEventListener('theme:cart:change', this.sync);
        document.removeEventListener('theme:cart-drawer:open', this.sync);
      }
      sync() {
        const items = [...this.drawer.querySelectorAll('[data-item]')];
        const variants = new Set(items.map(item => item.dataset.item.split(':')[0]));
        const rows = [...this.querySelectorAll('[data-rr-offer-row]')];
        rows.forEach(row => { row.hidden = variants.has(row.dataset.variant); });
        this.hidden = !items.some(item => item.dataset.rrCartOffer !== 'true') || rows.every(row => row.hidden);
        this.querySelectorAll('[data-rr-add-offer]').forEach(button => { button.disabled = !!this.busy; });
      }
      async request(path, body) {
        const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
          method: body === undefined ? 'GET' : 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          ...(body === undefined ? {} : { body: JSON.stringify(body) })
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(data.description || this.dataset.error);
        return data;
      }
      async add(button) {
        if (this.busy || this.drawer.classList.contains('is-loading')) return;
        this.busy = true;
        this.error.hidden = true;
        this.sync();
        button.classList.add('is-loading');
        const cartItems = this.drawer.querySelector('cart-items');
        cartItems.disableCartButtons();
        let addedKey;
        try {
          const before = await this.request('cart.js');
          if (before.items.some(item => String(item.variant_id) === button.dataset.variant)) return;
          const codes = [...new Set([...(before.discount_codes || []).map(discount => discount.code), 'REDRUM-CART-20'])];
          await this.request('cart/update.js', { discount: codes.join(',') });
          const added = await this.request('cart/add.js', { items: [{ id: button.dataset.variant, quantity: 1, properties: { __aov_upsell: true } }] });
          addedKey = added.items[0].key;
          const after = await this.request('cart.js');
          const offer = after.items.find(item => String(item.variant_id) === button.dataset.variant && item.properties.__aov_upsell);
          const applied = offer?.line_level_discount_allocations?.some(allocation => allocation.discount_application.title === 'REDRUM-CART-20');
          if (!applied) {
            if (offer) await this.request('cart/change.js', { id: offer.key, quantity: 0 });
            addedKey = null;
            throw new Error(this.dataset.error);
          }
          button.classList.add('is-added');
        } catch (error) {
          if (addedKey) {
            try {
              const current = await this.request('cart.js');
              const offer = current.items.find(item => String(item.variant_id) === button.dataset.variant && item.properties.__aov_upsell);
              if (offer) await this.request('cart/change.js', { id: offer.key, quantity: 0 });
            } catch (_) {}
          }
          this.error.textContent = error.message || this.dataset.error;
          this.error.hidden = false;
        } finally {
          this.busy = false;
          button.classList.remove('is-loading', 'is-added');
          cartItems.enableCartButtons();
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
